const EVENT_PAYLOAD_BASE_FIELDS = `
  activeTimeMinutes
  recurringEmailIntervalMinutes
  snoozeDurationMinutes
`;

const EVENT_PAYLOAD_SLEEP_FIELDS = `
  ${EVENT_PAYLOAD_BASE_FIELDS}
  sleepModeDurationMinutes
  socThreshold
  minVoltageThreshold
  maxVoltageThreshold
`;

const EVENT_PAYLOAD_WEAK_BATTERY_FIELDS = `
  ${EVENT_PAYLOAD_BASE_FIELDS}
  voltageThreshold
`;

const EVENT_NOTIFICATION_EVENTS_FIELDS = `
  GPMError { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GPMWarning { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GPMNotice { ${EVENT_PAYLOAD_BASE_FIELDS} }
  AcCurrentUnbalanceFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  AcHardwareOvercurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BatteryLow { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BatteryLowVoltageShutdown { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BMS1CommunicatonFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BMS2CommunicatonFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BMSOvervoltageProtection { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BMSUndervoltageProtection { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BMSVerFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  ZBTS5kSleepMode { ${EVENT_PAYLOAD_SLEEP_FIELDS} }
  BusHardwareOvervoltageFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BusOvervoltageFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  BusUnbalanceFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  CTError { ${EVENT_PAYLOAD_BASE_FIELDS} }
  EpsBatteryOvercurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan1Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan2Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan3Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan4Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan5Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan6Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  Fan7Failure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GridOverfrequency { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GridOvervoltage { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GridUnderfrequency { ${EVENT_PAYLOAD_BASE_FIELDS} }
  GridUndervoltage { ${EVENT_PAYLOAD_BASE_FIELDS} }
  InconsistentSoftwareVersion { ${EVENT_PAYLOAD_BASE_FIELDS} }
  InputModeSettingFailure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  InputOvercurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  InverterSoftStartFailure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  IslandingError { ${EVENT_PAYLOAD_BASE_FIELDS} }
  LeakageCurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  LowInsulationResistance { ${EVENT_PAYLOAD_BASE_FIELDS} }
  MeterError { ${EVENT_PAYLOAD_BASE_FIELDS} }
  OutputInstantaneousOvercurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  PVOvervoltage { ${EVENT_PAYLOAD_BASE_FIELDS} }
  PvUnevenCurrentFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  RelayDetectionFailure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  RelayUnbalancedPermanentFailure { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SCIError_AC { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SCIError_DC { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SCIError_Fuse { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SPICommError_AC { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SPICommError_DC { ${EVENT_PAYLOAD_BASE_FIELDS} }
  SafetyVerFault { ${EVENT_PAYLOAD_BASE_FIELDS} }
  WeakBattery { ${EVENT_PAYLOAD_WEAK_BATTERY_FIELDS} }
`;

export const AZZURRO_EVENT_CONFIGURATION_LIST_FRAGMENT = `
  fragment azzurroeventconfigurationdetail on AzzurroEventConfigurationDetail {
    alertCodes {
      G1
      G1_ZCS
      G2
      G2_ZCS
      G3
      G3_ZCS
    }
    generations
    defaultConfig {
      activeTimeMinutes
      maxVoltageThreshold
      voltageThreshold
      socThreshold
      snoozeDurationMinutes
      sleepModeDurationMinutes
      recurringEmailIntervalMinutes
      minVoltageThreshold
    }
    payloadType
    eventName
    description
  }
`;

export const EVENT_NOTIFICATION_BY_PLANTID_FRAGMENT = `
  fragment eventnotificationdata on EventNotificationData  {
    emails
    events {
      ${EVENT_NOTIFICATION_EVENTS_FIELDS}
    }
    plantId
  }
`;


export const EVENT_NOTIFICATION_CONFIG_FRAGMENT = `
  fragment eventnotificationconfig on EventNotificationConfig {
    success
    errors {
      errorType
      eventModelName
      message
    }
    data {
      emails
      events {
        ${EVENT_NOTIFICATION_EVENTS_FIELDS}
      }
      plantId
    }
  }
`;
